import type { Route } from '@angular/router';
import { permissionGuard } from '../../../../core/guards/permission.guard';
import { QuestionCatalogueStore } from './ask/question-catalogue.store';
import { AiAgentsContextStore } from './shared/ai-agents-context.store';

/**
 * AI Agents (`/ai-agents`, ruling D1). Every page is re-checked on in-area navigation: the admin shell's
 * `permissionGuard` runs only when the shell itself is entered. `aiAgentsAreaPermissions` gives each tab its group.
 * The consent page is NOT here: it is the top-level `ai-agents/consent` route in `app.routes.ts`.
 */
export const AI_AGENTS_ROUTE: Route = {
  path: 'ai-agents',
  providers: [AiAgentsContextStore, QuestionCatalogueStore],
  loadComponent: () => import('./shell/ai-agents-shell.component').then((m) => m.AiAgentsShellComponent),
  children: [
    { path: '', pathMatch: 'full', redirectTo: 'connect' },
    {
      path: 'connect',
      canActivate: [permissionGuard],
      loadComponent: () => import('./connect/ai-agents-connect-page.component').then((m) => m.AiAgentsConnectPageComponent),
    },
    {
      path: 'ask',
      canActivate: [permissionGuard],
      loadComponent: () => import('./ask/ai-agents-ask-page.component').then((m) => m.AiAgentsAskPageComponent),
    },
    {
      path: 'connections',
      canActivate: [permissionGuard],
      loadComponent: () => import('./connections/my-connections-page.component').then((m) => m.MyConnectionsPageComponent),
    },
    {
      path: 'all-connections',
      canActivate: [permissionGuard],
      loadComponent: () => import('./all-connections/all-connections-page.component').then((m) => m.AllConnectionsPageComponent),
    },
    {
      path: 'rollout',
      canActivate: [permissionGuard],
      loadComponent: () => import('./rollout/ai-agents-rollout-page.component').then((m) => m.AiAgentsRolloutPageComponent),
    },
    {
      path: 'activity',
      canActivate: [permissionGuard],
      loadComponent: () => import('./activity/ai-agents-activity-page.component').then((m) => m.AiAgentsActivityPageComponent),
    },
    {
      path: 'changes',
      canActivate: [permissionGuard],
      loadComponent: () => import('./changes/ai-agents-changes-page.component').then((m) => m.AiAgentsChangesPageComponent),
    },
  ],
};
